// extracted by mini-css-extract-plugin
module.exports = {"spinner-container":"dece2e673c--spinner-container--tvorZ"};